import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation, AfterViewInit } from '@angular/core';

import { fuseAnimations } from '@fuse/animations';
import { Subject, Observable, BehaviorSubject, merge } from 'rxjs';
import { DataSource } from '@angular/cdk/table';
import { takeUntil, tap } from 'rxjs/operators';
import { MatPaginator, MatSort, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { DownloadService } from '@fuse/services/download/download.service';
import { CompanyService } from '@fuse/services/company.service';
import { TranslateService } from '@ngx-translate/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

@Component({
    selector: 'download-list',
    templateUrl: './download-list.component.html',
    styleUrls: ['./download-list.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class DownloadListComponent implements OnInit, OnDestroy {
    private _unsubscribeAll: Subject<any>;

    displayedColumns = ['name', 'description', 'created_at'];
    downloads: any;
    totalPages = 2;
    totalElements = 0;
    sortField = 'created_at';
    sordOrder = 'desc';
    pageSize = 10;
    lang = 'sr';
    company: any;

    @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: true }) sort: MatSort;

    constructor(
        private _downloadService: DownloadService,
        public _matDialog: MatDialog,
        private _matSnackBar: MatSnackBar,
        private _translate: TranslateService,
        private _translationLoader: FuseTranslationLoaderService,
        private _companyService: CompanyService
    ) {
        this._unsubscribeAll = new Subject();
    }

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '24');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    listDownloads(): void {
        this._companyService.getActiveCompany()
        .then(response => {
            this.company = response;
            console.log(this.company);
        })
        .catch(err => Promise.reject(err))
        .then(() => {
            this._translationLoader.getLastLang()
                .then(response => {
                    this.lang = response['code'];
                })
                .catch(err => Promise.reject(err))
                .then(() => {
                    this._downloadService.listDownloads(this.company.id, this.lang)
                        .then(response => {
                            this.downloads = response.data;
                            console.log(this.downloads);
                        })
                        .catch(err => Promise.reject(err))
                        .then(() => {
                        }, err => {
                        });   
                }, err => {
                });
        }, err => {
        });
    }

    downloadDocument(itemId, filename): void {
        this._downloadService.downloadDocument(this.company.id, itemId, filename);
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    ngOnInit(): void {

        this.listDownloads();   

        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this.listDownloads();
            });

        this._companyService.onCompanyChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                this.listDownloads();     
            });

        this.getTranslations();

    }

    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
